module.exports = __webpack_public_path__ + "img/i.7f9d2c62.svg";